import Toastr from "../../../itrust_common/components/Toastr"
const DEFAULT_STATE = {
  orders: [],
  order: {},
  meta: { pagination: {} },
  saving: false,
  editing: false,
  loading: false,
  isFormChanged: false,
  versions: [],
  versionsLoading: false,
  loadingSubOrderId: null,
  verifyingCatalog: false,
  verifiedCatalog: null
}
let changes = null;
export default function orderReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let orders = [];
  let orderData = [];
  let updatedRecord = {};
  switch (action.type) {
    case 'ORDER_LOAD_PENDING':
    case 'ORDER_NEW_LOAD_PENDING':
      return { ...state, saving: true };

    case 'ORDERS_LOAD_PENDING':
      return { ...state, saving: true, loading: true };

    case 'ORDER_CREATE_PENDING':
    case 'ORDER_UPDATE_PENDING':
      return { ...state, saving: true };

    case 'ORDERS_LOAD_REJECTED':
    case 'ORDER_LOAD_REJECTED':
    case 'ORDER_CREATE_REJECTED':
    case 'ORDER_DELETE_REJECTED':
    case 'ORDER_UPDATE_REJECTED':
    case 'DUPLICATE_ORDER_CREATE_REJECTED':
    case 'ORDER_INVOICE_PRINT_REJECTED':
    case 'ORDER_INVOICE_DOWNLOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false, loading: false, }
      return { ...state, ...changes };

    case 'ORDERS_LOAD_FULFILLED':
      changes = { ...response, saving: false, loading: false };
      return { ...state, ...changes };

    case 'ORDER_LOAD_FULFILLED':
      changes = {
        order: response.order,
        saving: false
      }
      return { ...state, ...changes };

    case 'ORDER_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      orders = [...state.orders]
      let newRecord = response.order
      changes = {
        orders: [...orders, newRecord],
        order: newRecord,
        saving: false
      }
      return { ...state, ...changes };

    case 'DUPLICATE_ORDER_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      orders = [...state.orders]
      updatedRecord = response.order
      changes = {
        orders: [...orders, updatedRecord],
        saving: false
      }
      return { ...state, ...changes };

    case 'ORDER_UPDATE_FULFILLED':
    case 'ORDER_PROMOTION_APPLY_FULFILLED':
    case 'ORDER_PROMOTION_REMOVE_FULFILLED':
    case 'ORDER_WARRANTY_APPLY_FULFILLED':
      Toastr.handleShow(true, response?.meta?.message || 'Order updated successfully', 201)
      orders = [...state.orders];
      updatedRecord = response.order;
      for (const [index, order] of orders.entries()) {
        if (order.id === updatedRecord.id) {
          orderData = [
            ...orders.slice(0, index),
            updatedRecord,
            ...orders.slice(index + 1)
          ];
        }
      }
      changes = {
        orders: orderData,
        order: updatedRecord,
        meta: { ...state.meta, ...response.meta },
        saving: false
      };
      return { ...state, ...changes };

    case 'ORDER_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      orders = [...state.orders];
      for (const [index, order] of orders.entries()) {
        if (order.id === response.order.id) {
          orders.splice(index, 1);
        }
      }
      return {
        ...state,
        orders: orders,
        error: null
      };

    case 'ORDER_INVOICE_EMAIL_FULFILLED':
      Toastr.handleShow(true, response.message, 201)
      return { ...state, ...changes };

    case 'ORDER_PROCEDURE_IMPRESSION_REORDER':
      orderData = state.order;
      changes = {
        order: { ...orderData, ...action.data },
      };
      return { ...state, ...changes };

    case 'ORDER_EDIT':
      changes = {
        editing: {
          id: action.id,
          data: action.data
        },
      };
      return { ...state, ...changes };

    case 'ORDER_EDIT_CANCEL':
      changes = {
        editing: false
      };
      return { ...state, ...changes };

    case 'ORDER_RESET':
      return { ...state, ...DEFAULT_STATE };

    case 'ORDER_ORDER_RESET':
      return { ...state, order: {} };

    case 'ORDER_CLOSE_MODAL':
      return { ...state, isFormChanged: action.payload };

    case 'ORDER_VERSIONS_LOAD_PENDING':
      return {
        ...state,
        versionsLoading: true,
        loadingSubOrderId: action.meta?.subOrderId
      };

    case 'ORDER_VERSIONS_LOAD_FULFILLED':
      return {
        ...state,
        versions: response.versions || response.data || [],
        versionsLoading: false,
        loadingSubOrderId: null
      };

    case 'ORDER_VERSIONS_LOAD_REJECTED':
      return {
        ...state,
        versionsLoading: false,
        loadingSubOrderId: null
      };

    case 'ORDER_VERIFY_CATALOG_PENDING':
      return {
        ...state,
        verifyingCatalog: true
      };

    case 'ORDER_VERIFY_CATALOG_FULFILLED': {
      const message = response?.error || response?.message;

      Toastr.handleShow(
        !!response?.success,
        message,
        response?.status_code || 200
      );

      return {
        ...state,
        verifyingCatalog: false,
        verifiedCatalog: response
      };
    }

    case 'ORDER_VERIFY_CATALOG_REJECTED': {
      const errorMsg =
        response?.data?.message ||
        response?.data?.errors ||
        action?.payload?.message ||
        response?.message ||
        'Something went wrong';

      Toastr.handleShow(false, errorMsg, response?.data?.status_code || 422);

      return {
        ...state,
        verifyingCatalog: false,
        verifiedCatalogError: response
      };
    }

    default:
      return state;
  }
}